"use strict";

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass.js").default;

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck.js").default;

var _inherits = require("/app/node_modules/@babel/runtime/helpers/inherits.js").default;

var _createSuper = require("/app/node_modules/@babel/runtime/helpers/createSuper.js").default;

var _wrapNativeSuper = require("/app/node_modules/@babel/runtime/helpers/wrapNativeSuper.js").default;

var BottleneckError;

BottleneckError = /*#__PURE__*/function (_Error) {
  _inherits(BottleneckError, _Error);

  var _super = _createSuper(BottleneckError);

  function BottleneckError() {
    _classCallCheck(this, BottleneckError);

    return _super.apply(this, arguments);
  }

  return _createClass(BottleneckError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

module.exports = BottleneckError;